import { render, staticRenderFns } from "./UserBasedContent.vue?vue&type=template&id=5b6a2d0c"
import script from "./UserBasedContent.vue?vue&type=script&lang=js"
export * from "./UserBasedContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports